
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./App": () => {
return Promise.all(/*  | __federation_expose_App */ [__webpack_require__.e("90745"), __webpack_require__.e("66362")]).then(() => (() => (__webpack_require__(59680))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };